export const createLazyImageObserver = (): IntersectionObserver => {
  return new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target as HTMLImageElement;
          const src = img.dataset.src;
          if (src) {
            img.src = src;
            img.removeAttribute('data-src');
            img.classList.remove('lazy-loading');
            img.classList.add('lazy-loaded');
          }
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '50px'
    }
  );
};

export const preloadCriticalResources = () => {
  // Preload critical images
  const criticalImages = ['/logo.png'];
  
  criticalImages.forEach(src => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
};

export const optimizeForMobile = () => {
  // Disable smooth scrolling on mobile for better performance
  const isMobile = window.innerWidth < 768;
  if (isMobile) {
    document.documentElement.style.scrollBehavior = 'auto';
  }
};
